/**
 * Centralized Feature Flags
 *
 * This file contains all feature flag keys used throughout the application.
 * Using these constants instead of hardcoded strings ensures:
 * - Consistent flag naming across the codebase
 * - Easy identification of all flags in use
 * - Single source of truth for flag names
 *
 * Usage:
 *   import { FeatureFlag } from "../../domain/enums/featureFlags"
 *   const isEnabled = useFeatureFlagEnabled(FeatureFlag.IsQaEnabled)
 */

export enum FeatureFlag {
  // QA & Development
  IsQaEnabled = "is_QA_enabled",
  IsDirectusOverrideEnabled = "is-directus-override-enabled",

  // M1 Features
  IsM131DimplImportToolEnabled = "is_M1-3-1_DIMPL-Import-Tool_enabled",
  IsM14BannersEnabled = "is_M1-4_Banners_enabled",

  // Search Features
  WhatAffiliateSearchScoringProfile16646Enabled = "what-Affiliate-Search-Scoring-Profile-16646-enabled",
  WhatAffiliateSearchScoringProfileProviderEnabled = "what-Affiliate-Search-Scoring-Profile-Provider",
  WhatAffiliateSearchScoringProfilePracticeEnabled = "what-Affiliate-Search-Scoring-Profile-Practice",
  WhatQuickSearchScoringProfileProviderEnabled = "what-Quick-Search-Scoring-Profile-Provider",
  WhatQuickSearchScoringProfilePracticeEnabled = "what-Quick-Search-Scoring-Profile-Practice",
  WhatQuickSearchScoringProfileReferralEnabled = "what-Quick-Search-Scoring-Profile-Referral",
  WhatQuickSearchScoringProfileAffiliateEnabled = "what-Quick-Search-Scoring-Profile-Affiliate",
  IsAdvancedSearchRevampEnabled = "is-Advanced-Search-Revamp-18848-enabled",
  IsAffiliateSearchMapView1016Enabled = "is_AffilRel_CareMgr_Map_View_1016_Enabled",

  // Payments & Referrals
  IsCaseView18842Enabled = "is-Case-View-18842-enabled",
  IsCaseViewSecureCase19844Enabled = "is-Case-View-Secure-Case-19844-enabled",
  IsMemberIntakeCaseInfo19985Enabled = "is-Member-Intake-Case-Info-19985-enabled",

  // Tax Info

  // Provider Photo
  IsProviderPhotoCrop16564Enabled = "is-Provider-Photo-Crop-16564-enabled",

  // UI Features
  IsUIOptimizations12699Enabled = "is-UI-Optimizations-12699-enabled",
  IsProviderCaptureNPI12749Enabled = "is-Provider-Capture-NPI-12749-enabled",

  // Provider Services (formerly Locations)
  IsNoVirtualLocationEnabled = "is-No-Virtual-Location-enabled",

  // Affiliate Relations
  IsProviderOrphanSupport16529Enabled = "is-Provider-Orphan-Support-16529-enabled",

  // Referral Transfer
  IsCaseViewExportUserName19866Enabled = "is-Case-View-Export-User-Name-19866-enabled",
  IsSessionDateValidation15983Enabled = "is-Session-Date-Validation-15983-enabled",

  // Practice Agreement
  IsPracticeAgreementSignatureRequired20409Enabled = "is-Practice-Agreement-Signature-Required-20409-enabled",
  IsResetRemoveAgreements20047Enabled = "is-Reset-Remove-Agreements-20047-enabled",

  // Practice Profile
  IsGroupLiabilityAttestationEnabled = "is-Group-Liability-Attestation-enabled",
  // Help Content Update
  IsUpdateHelpContent20783Enabled = "is-Update-Help-Content-20783-enabled",

  // System Alert
  IsSystemAlertBlueColor21381Enabled = "is-System-Alert-Blue-Color-21381-Enabled",
}
